import {Component, OnInit} from '@angular/core';
import {AppConfigService} from '../Services/app-config.service';

@Component({
  selector: 'app-login-layout',
  template: `<router-outlet></router-outlet>`,
  styles: [],
  standalone: false
})

export class LoginLayoutComponent implements OnInit {

  constructor(private appConfig: AppConfigService) {
  }

  ngOnInit(): void {
    document.body.setAttribute('data-bs-theme', this.appConfig.getEffectiveTheme());
    const savedLayout = localStorage.getItem('layout') || 'vertical';
    document.documentElement.setAttribute('data-layout', savedLayout);
  }

}
